import React from "react";
import { isFunction } from "lodash";
import { isPlayEnv } from "helpers/helper";
import TexadaLogo from "../../../public/img/TexadaLogo";
import "./Login.scss";

interface MainScreenProps {
  children: React.ReactNode | (() => React.ReactNode);
}

const MainScreen: React.FC<MainScreenProps> = props => {
  return (
    <div className="login">
      <div className="login_container">
        <TexadaLogo className={`texada-logo ${isPlayEnv() && "play"}`} />
        {isPlayEnv() && <p className="play-tag">PLAY ENVIRONMENT</p>}
        {isFunction(props.children) ? props.children() : props.children}
      </div>
    </div>
  );
};

export default MainScreen;
